<template>
  <b-container v-if="REGION_TOOLBAR.isVisible"
               class="us-region-toolbar-container"
               :style="style">
    <div>
      <b-button-toolbar class="us-region-toolbar us-color-picker-target"
                        key-nav
                        aria-label="Toolbar with button groups">
        <b-button-group v-for="(group, index) in toolGroups"
                        :key="index"
                        class="mx-1">
          <b-btn v-for="tool in group"
                 v-if="toolIsEnabled(tool)"
                 :key="tool"
                 :class="`annotation-icon-${tool}`"
                 :title="$t(`tooltips.${tool}`)"
                 @click="onToolClick(tool, $event)"/>
        </b-button-group>
        <b-button-group v-if="addOns.length > 0">
          <component v-for="addOn in addOns"
                     :key="addOn.key"
                     :is="addOn.button"/>
        </b-button-group>
      </b-button-toolbar>
    </div>

    <b-container>
      <component v-for="panel in panels"
                 :key="panel.key"
                 :is="panel.ui"/>
    </b-container>

  </b-container>
</template>

<script>
  import { mapState } from 'shared/stores/core/helpers';
  import { getEventPath } from 'uScope/js/lib/utility/dom-helpers';
  import { addPointerListener } from 'uScope/js/lib/utility/pointerApi';
  import { toolbarMixin } from './toolbar-mixin';

  export default {
    name: 'RegionToolbar',
    i18nOptions: { keyPrefix: 'uScope.extensions.annotations' },
    mixins: [toolbarMixin],
    props: {
      addOns: {
        type: Array,
        default () { return []; }
      },
      panels: {
        type: Array,
        default () { return []; }
      }
    },

    data () {
      return {
        toolGroups: [
          ['trash', 'color', 'note'],
          ['copy', 'move', 'redraw']
        ]
      };
    },

    computed: {
      ...mapState('REGION_TOOLBAR'),
      style () {
        return {
          top: this.REGION_TOOLBAR.position.clientY + 'px',
          left: this.REGION_TOOLBAR.position.clientX + 'px'
        };
      }
    },

    methods: {
      onToolClick (tool, event) {
        this.runTool(tool, event);
        this.$dispatch('HIDE_REGION_TOOLBAR');
      }
    },

    mounted () {
      addPointerListener(document, 'mousedown', (e) => {
        if (this.REGION_TOOLBAR.isVisible) {
          const eventPath = getEventPath(e);
          if (!eventPath.includes(this.$el)) {
            this.$dispatch('HIDE_REGION_TOOLBAR');
          }
        }
      });
    }
  };
</script>

<style lang="scss" scoped>
    @import "toolbar-button.scss";

    .us-region-toolbar-container {
        position: absolute;
        background: white;
    }

    .us-region-toolbar {
        display: flex; // Causes button groups to align in a row
        padding: 5px;
        background: white;
        border: 1px solid $border-color;

        @extend %tool-button-container;

        > div {
          display: flex;
          flex-wrap: nowrap;
        }
    }
</style>



// WEBPACK FOOTER //
// src/uScope/js/extensions/annotations/annotations-ui/RegionToolbar.vue